<template>
  <vuex-table
    class="users-table"
    :fields="fields"
    :filter_items="filtered_fields"
    table_store="amo_widget/users/table"
  >
    <template slot="type" slot-scope="{ item }">
      {{ $t(`voice.trunk.type.${item.type}`) }}
    </template>

    <template slot="sip_account" slot-scope="{ item }">
      <sip-account :login="item.sip_login" :password="item.sip_password" />
    </template>

    <template #client="{ detailsShowing, toggleDetails, item }">
      <div class="mainip_more">
        <span>{{ item.client }}</span>
        <table-button-more :is_show="detailsShowing" :is_text="false" @click="toggleDetails" />
      </div>
    </template>

    <template #row-details="{ item }">
      <table-ips :id="item.id" :server="item.server" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="edit_item(item)">
          {{ $t('shared.component.table.action.edit') }}
        </span>
      </table-dropdown>
    </template>
    <template slot="state" slot-scope="{ formatted: value }">
      <status-badge :value="value" />
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { AmoUserModalService } from '@integrations/modals/AmoUserModalService';
  import StatusBadge from '@voice/components/sip-badge-state';
  import { DATA } from '@/plugins/vuex-async-pagginate';
  import TableButtonMore from '@shared/components/table/table-cell-toggle-detail';
  import SipAccount from './sip_account_toggle';

  export default {
    components: {
      StatusBadge,
      TableButtonMore,
      SipAccount
    },

    props: {
      filtred_data: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters('amo_widget/users/table', { items: DATA }),

      filtered_fields: function () {
        if (!this.filtred_data) return this.items;

        return this.items.filter((f) => {
          return f.service_name === this.filtred_data;
        });
      },
      fields: function () {
        return [
          {
            key: 'status',
            label: this.$t('integrations.users_table.tech_status'),
            sortable: false,
            formatter: (value) =>
              value
                ? this.$t(`integrations.users_status.${value}`)
                : this.$t(`integrations.users_status_default`),
            class: 'w-5'
          },
          {
            key: 'amo_name',
            label: this.$t('integrations.users_table.amo_name'),
            sortable: false,
            class: 'w-5'
          },
          {
            key: 'amo_email',
            label: this.$t('integrations.users_table.amo_login'),
            sortable: false,
            class: 'w-5'
          },
          {
            key: 'sip_account',
            label: this.$t('integrations.users_table.sip_account'),
            sortable: false,
            class: 'w-5'
          },
          {
            key: 'caller_id',
            label: this.$t('integrations.users_table.caller_id'),
            sortable: false,
            class: 'w-5'
          },
          {
            key: 'queue.name',
            label: this.$t('integrations.users_table.queue'),
            sortable: false,
            class: 'w-5'
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'w-10 table-actions'
          }
        ];
      }
    },

    methods: {
      ...mapActions('amo_widget/users/table', ['getAsyncData', 'updateItemById']),
      edit_item: function (item) {
        AmoUserModalService.edit(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>

<style lang="scss">
  .users-table {
    td {
      vertical-align: middle;
    }
  }
  .w-5 {
    width: 5%;
  }

  .w-10 {
    width: 10%;
  }

  .table-edit td {
    vertical-align: top;
  }

  table .pos-r {
    position: relative;
  }

  .mainip_more {
    a.table-button-more {
      position: absolute;
      left: 140px;
      display: block;
      top: 15px;
    }
  }
</style>
